export default __webpack_public_path__ + "static/media/lumsum.854712d0.svg";